export default __webpack_public_path__ + "static/media/Declaration of Independence_10.7b493e4c.jpg";